import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import Inventory from './pages/Inventory';
import Offers from './pages/Offers';
import Customers from './pages/Customers';
import Orders from './pages/Orders';
import Sourcers from './pages/Sourcers';
import SourcingOrders from './pages/SourcingOrders';
import BalanceSheet from './pages/BalanceSheet';
import Guide from './pages/Guide';
import Manufacturing from './pages/Manufacturing';
import Settings from './pages/Settings';
import SimpleViewGuard from './components/SimpleViewGuard';
import Landing from './pages/Landing';
import Storefront from './pages/Storefront';
import { parseSubdomain } from './utils/subdomain';

const Placeholder = ({ title }) => (
  <div className="p-6">
    <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
    <p className="text-sm text-gray-500 mt-1">Coming soon.</p>
  </div>
);

const { type, slug } = parseSubdomain();

function App() {
  if (type === 'landing') return <Landing />;
  if (type === 'storefront') return <Storefront slug={slug} />;

  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/sourcers" element={<SimpleViewGuard><Sourcers /></SimpleViewGuard>} />
            <Route path="/sourcing-orders" element={<SimpleViewGuard><SourcingOrders /></SimpleViewGuard>} />
            <Route path="/balance-sheet" element={<BalanceSheet />} />
            <Route path="/expenses" element={<Navigate to="/balance-sheet" replace />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/team" element={<Navigate to="/settings?tab=team" replace />} />
            <Route path="/manufacturing" element={<SimpleViewGuard><Manufacturing /></SimpleViewGuard>} />
            <Route path="/api-keys" element={<Navigate to="/settings?tab=api-keys" replace />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
